import i18n from '../i18n';

export function setAppLanguage(code: string): void {
  void i18n.changeLanguage(code);
  localStorage.setItem('lang', code);
}

export function getAppLanguage(): string {
  return i18n.language || localStorage.getItem('lang') || 'en';
}
